"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateNumericalResults = exports.calculateResults = exports.resultsToHtml = exports.retrieveSurvey = void 0;

var onboardingV1x1 = _interopRequireWildcard(require("./onboarding/onboarding-v1.1"));

var onboardingV1 = _interopRequireWildcard(require("./onboarding/onboarding-v1"));

var onboardingMedibankV1 = _interopRequireWildcard(require("./onboarding/onboarding-medibank-v1"));

var onboardingAllianzV1 = _interopRequireWildcard(require("./onboarding/onboarding-allianz-v1"));

var personalisationV1 = _interopRequireWildcard(require("./personalisation/personalisation-v1"));

var coronaAnxietyOddsV1 = _interopRequireWildcard(require("./exercises/survey-corona-anxiety-odds-v1"));

var coronaAnxietyPositivesV1 = _interopRequireWildcard(require("./exercises/survey-corona-anxiety-positives-v1"));

var coronaToleratingUncertaintyV1 = _interopRequireWildcard(require("./exercises/survey-corona-tolerating-uncertainty-v1"));

var coronaBeliefsAboutHealthAnxietyCheckingV1 = _interopRequireWildcard(require("./exercises/survey-corona-beliefs-about-health-anxiety-checking-v1"));

var sleepChecklistV1 = _interopRequireWildcard(require("./exercises/sleep-checklist-v1"));

var focusQuestionV1 = _interopRequireWildcard(require("./exercises/survey-focus-question-v1"));

var motivationalInterviewingAddictions = _interopRequireWildcard(require("./exercises/motivational-interviewing-addictions-v1.js"));

var selfTestGambling = _interopRequireWildcard(require("./exercises/self-test-gambling-v1.js"));

var selfTestDrugUse = _interopRequireWildcard(require("./exercises/self-test-drug-use-v1.js"));

var selfTestHazardousDrinking = _interopRequireWildcard(require("./exercises/self-test-hazardous-drinking-v1.js"));

var selfCantPersonCan = _interopRequireWildcard(require("./exercises/self-cant-change-person-can-v1.js"));

var willingnessTrustLettingGoAddictedSelf = _interopRequireWildcard(require("./exercises/willingness-trust-letting-go-addicted-self-v1.js"));

var personalFormulaForHappiness = _interopRequireWildcard(require("./exercises/personal-formula-happiness-v1.js"));

var leaderTeamWellbeingAssesment = _interopRequireWildcard(require("./exercises/leader-team-wellbeing-assesment-v1.js"));

var buildingEmpathy = _interopRequireWildcard(require("./exercises/building-empathy-v1.js"));

var stressTriggers = _interopRequireWildcard(require("./exercises/stress-triggers-v1.js"));

var introductionWorryTime = _interopRequireWildcard(require("./exercises/introduction-worry-time-v1.js"));

var worryTimeExercise = _interopRequireWildcard(require("./exercises/worry-time-exercise-v1.js"));

var onboardingStudentsV1 = _interopRequireWildcard(require("./onboarding/onboarding-students-v1.0"));

var stressV1 = _interopRequireWildcard(require("./stressCheck/stress-check-v1"));

var wellbeingV1 = _interopRequireWildcard(require("./wellbeingCheck/wellbeing-check-v1"));

var valuesV1 = _interopRequireWildcard(require("./exercises/values-v1"));

var retrainingThinkingV1 = _interopRequireWildcard(require("./exercises/retraining-thinking-v1"));

var retrainingThinkingRevisionV1 = _interopRequireWildcard(require("./exercises/retraining-thinking-revision-v1"));

var retrainingThinkingMetacognitionV1 = _interopRequireWildcard(require("./exercises/retraining-thinking-metacognition-v1"));

var retrainingThinkingBeliefsV1 = _interopRequireWildcard(require("./exercises/retraining-thinking-beliefs-v1"));

var retrainingThinkingStressV1 = _interopRequireWildcard(require("./exercises/retraining-thinking-stress-v1"));

var retrainingThinkingSleepPredictionsV1 = _interopRequireWildcard(require("./exercises/retraining-thinking-sleep-predictions-v1"));

var retrainingThinkingSleepThoughtsV1 = _interopRequireWildcard(require("./exercises/retraining-thinking-sleep-thoughts-v1"));

var retrainingThinkingFocusV1 = _interopRequireWildcard(require("./exercises/retraining-thinking-focus-v1.js"));

var progressV1 = _interopRequireWildcard(require("./progress/progress-v1"));

var progressRtwV1 = _interopRequireWildcard(require("./progress/progress-rtw-v1"));

var progressRtwV1x1 = _interopRequireWildcard(require("./progress/progress-rtw-v1.1"));

var progressRtwV1x2 = _interopRequireWildcard(require("./progress/progress-rtw-v1.2"));

var progressRtwUsV1 = _interopRequireWildcard(require("./progress/progress-rtw-us-v1.0"));

var progressRtw3MonthsV1 = _interopRequireWildcard(require("./progress/progress-rtw-3-month-v1"));

var progressRtwUs3MonthsV1 = _interopRequireWildcard(require("./progress/progress-rtw-us-3-month-v1"));

var perspectiveTakingV1 = _interopRequireWildcard(require("./exercises/perspective-taking-v1.js"));

var guiltV1 = _interopRequireWildcard(require("./exercises/guilt-v1.js"));

var onboardingRtwV1 = _interopRequireWildcard(require("./onboarding/onboarding-rtw-v1"));

var onboardingRtwV1x1 = _interopRequireWildcard(require("./onboarding/onboarding-rtw-v1.1"));

var onboardingUsRtwV1 = _interopRequireWildcard(require("./onboarding/onboarding-rtw-us-v1.0"));

var onboardingUsRtwV1x1 = _interopRequireWildcard(require("./onboarding/onboarding-rtw-us-v1.1"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
} // v1.0


var exerciseRetrainingThinking = require("./exercises/exercise-retrainingthinking");

var exercisePerspectiveTaking = require("./exercises/exercise-perspectivetaking1"); // Advanced mindset - retraining thinking 2


var retraining2exercise1 = require("./old/retrainingthinking2/exercise1");

var retraining2exercise2 = require("./old/retrainingthinking2/exercise2");

var retraining2RevisionExercise1 = require("./old/retrainingthinking2/revision/exercise1");

var retraining2StressExercise1 = require("./old/retrainingthinking2/stress/exercise1");

var retraining2GuiltExercise1 = require("./old/retrainingthinking2/guilt/exercise1");

var retraining2MetacognitionExercise1 = require("./old/retrainingthinking2/metacognition/exercise1");

var retraining2BeliefsExercise1 = require("./old/retrainingthinking2/beliefs/exercise1");

var exerciseBalance = require("./exercises/exercise-balance");

var wellnessCheck = require("./wellnesscheckOLD/wellnesscheck-v1");

var wellnessCheckStudents = require("./wellnesscheckOLD/students-wellnesscheck-v1");

var wellnessCheck15Q = require("./wellnesscheckOLD/wellnessCheck15Q");

var wellbeingStressWeeklyV1 = require("./wellbeingStressWeekly/wellbeingStressWeekly-v1");

var wellbeingStressWeeklyV1x1 = require("./wellbeingStressWeekly/wellbeingStressWeekly-v1.1");

var wellbeingStressMonthlyV1 = require("./wellbeingStressMonthly/wellbeingStressMonthly-v1");

var wellbeingStressMonthlyV1x1 = require("./wellbeingStressMonthly/wellbeingStressMonthly-v1.1");
/*Medibank*/


var wellbeingStressWeeklyMedibankV1 = require("./wellbeingStressWeekly/wellbeingStressWeekly-medibank-v1");

var wellbeingStressMonthlyMedibankV1 = require("./wellbeingStressMonthly/wellbeingStressMonthly-medibank-v1");

var wellbeingStressMonthlyMedibankV1x2 = require("./wellbeingStressMonthly/wellbeingStressMonthly-medibank-v1.2");
/*Allianz*/


var wellbeingStressWeeklyAllianzV1 = require("./wellbeingStressWeekly/wellbeingStressWeekly-allianz-v1");

var wellbeingStressMonthlyAllianzV1 = require("./wellbeingStressMonthly/wellbeingStressMonthly-allianz-v1");

var wellbeingAllianzV1 = require("./wellbeingCheck/wellbeing-check-allianz-v1");
/* RTW */

/* Onboarding */


var problemDefinition = require("./rtw/exercise-problem-definition");

var problemSolution = require("./rtw/exercise-problem-solution");

var beforeExperiment = require("./rtw/exercise-before-experiment");

var afterExperiment = require("./rtw/exercise-after-experiment");
/* RTW 2.0 */


var problemDefinitionV1 = require("./rtw/exercises/exercise-problem-definition");

var problemSolutionV1 = require("./rtw/exercises/exercise-problem-solution");

var beforeExperimentV1 = require("./rtw/exercises/exercise-before-experiment");

var afterExperimentV1 = require("./rtw/exercises/exercise-after-experiment");

var rtwPreScreenerV1 = require("./rtw/pre-screener-v1");
/* Pre program */


var preV1 = require("./preprogram/preprogram-v1");

var preV1x2 = require("./preprogram/preprogram-v1-2");

var preV1x3 = require("./preprogram/preprogram-v1-3");

var preV1x4 = require("./preprogram/preprogram-v1-4");

var preV1x5 = require("./preprogram/preprogram-v1-5");

var preLLV1x5 = require("./preprogram/preprogram-LLv1-5");

var preV1x6 = require("./preprogram/preprogram-v1-6");

var preV1x6x1 = require("./preprogram/preprogram-v1-6-1");

var preV1x7 = require("./preprogram/preprogram-v1-7");
/* Pre program - students */


var preV1x6Students = require("./preprogram/students-preprogram-v1-6");

var preV1x7Students = require("./preprogram/students-preprogram-v1-7");
/* Pre program - RTW */


var preV1Rtw = require("./preprogram/rtw-preprogram-v1");
/* Post program */


var postV1 = require("./postprogram/postprogram-v1");

var postV1x2 = require("./postprogram/postprogram-v1-2");

var postV1x3 = require("./postprogram/postprogram-v1-3");

var postV1x4 = require("./postprogram/postprogram-v1-4");

var postV1x5 = require("./postprogram/postprogram-v1-5");

var postV1x6 = require("./postprogram/postprogram-v1-6");

var monthlySurvey = require("./monthly-survey/monthly-survey-v1");

var monthlySurveyV1x1 = require("./monthly-survey/monthly-survey-v1.1"); // const monthlySurveyStudents = require("./monthly-survey/students-monthly-survey-v1");

/* Allianz Progress */


var allianzProgressV1 = require("./progress/progress-allianz-v1");
/* Medibank Progress */


var medibankProgressV1 = require("./progress/progress-medibank-v1");

var medibankProgressV1x1 = require("./progress/progress-medibank-v1.1");

var medibankProgressV1x2 = require("./progress/progress-medibank-v1.2");
/* Medibank Onboarding v1 */


var onboardingMedibankV1x1 = require("./onboarding/onboarding-medibank.v1.1");
/* Wellbeing Weekly V1 */


var wellbeingStressWeeklyMedibankV1x1 = require("./wellbeingStressWeekly/wellbeingStressWeekly-medibank-v1.1");

var wellbeingStressWeeklyMedibankV1x2 = require("./wellbeingStressWeekly/wellbeingStressWeekly-medibank-v1.2");

var retrieveSurvey = function retrieveSurvey(surveyId) {
  switch (surveyId) {
    case "building-empathy-v1":
      return buildingEmpathy;

    case "leader-team-wellbeing-assesment-v1":
      return leaderTeamWellbeingAssesment;

    case "self-test-gambling-v1":
      return selfTestGambling;

    case "self-test-drug-use-v1":
      return selfTestDrugUse;

    case "self-test-hazardous-drinking-v1":
      return selfTestHazardousDrinking;

    case "self-cant-change-person-can-v1":
      return selfCantPersonCan;

    case "willingness-trust-letting-go-addicted-self-v1":
      return willingnessTrustLettingGoAddictedSelf;

    case "personal-formula-happiness-v1":
      return personalFormulaForHappiness;
    // v2.0'

    case "motivational-interviewing-addictions-v1":
      return motivationalInterviewingAddictions;

    case "survey-corona-anxiety-odds-v1":
      return coronaAnxietyOddsV1;

    case "survey-corona-anxiety-positives-v1":
      return coronaAnxietyPositivesV1;

    case "survey-corona-tolerating-uncertainty-v1":
      return coronaToleratingUncertaintyV1;

    case "survey-corona-beliefs-about-health-anxiety-checking-v1":
      return coronaBeliefsAboutHealthAnxietyCheckingV1;

    case "onboarding-rtw-v1":
      return onboardingRtwV1;

    case "onboarding-rtw-v1.1":
      return onboardingRtwV1x1;

    case "onboarding-rtw-us-v1.0":
      return onboardingUsRtwV1;

    case "onboarding-rtw-us-v1.1":
      return onboardingUsRtwV1x1;

    case "onboarding-v1":
      return onboardingV1;

    case "onboarding-medibank-v1":
      return onboardingMedibankV1;

    case "onboarding-allianz-v1":
      return onboardingAllianzV1;

    case "onboarding-v1.1":
      return onboardingV1x1;

    case "wellbeingStressWeekly-v1":
      return wellbeingStressWeeklyV1;

    case "wellbeingStressWeekly-v1.1":
      return wellbeingStressWeeklyV1x1;

    case "wellbeingStressMonthly-v1":
      return wellbeingStressMonthlyV1;

    case "wellbeingStressMonthly-v1.1":
      return wellbeingStressMonthlyV1x1;

    case "wellbeingStressWeekly-medibank-v1":
      return wellbeingStressWeeklyMedibankV1;

    case "wellbeingStressWeekly-allianz-v1":
      return wellbeingStressWeeklyAllianzV1;

    case "wellbeingStressMonthly-medibank-v1":
      return wellbeingStressMonthlyMedibankV1;

    case "wellbeingStressMonthly-medibank-v1.2":
      return wellbeingStressMonthlyMedibankV1x2;

    case "wellbeingStressMonthly-allianz-v1":
      return wellbeingStressMonthlyAllianzV1;

    case "personalisation-v1":
      return personalisationV1;

    case "wellbeing-check-v1":
      return wellbeingV1;

    case "wellbeing-check-allianz-v1":
      return wellbeingAllianzV1;

    case "stress-check-v1":
      return stressV1;

    case "retraining-thinking-v1":
      return retrainingThinkingV1;

    case "retraining-thinking-revision-v1":
      return retrainingThinkingRevisionV1;

    case "retraining-thinking-metacognition-v1":
      return retrainingThinkingMetacognitionV1;

    case "retraining-thinking-beliefs-v1":
      return retrainingThinkingBeliefsV1;

    case "retraining-thinking-stress-v1":
      return retrainingThinkingStressV1;

    case "retraining-thinking-sleep-predictions-v1":
      return retrainingThinkingSleepPredictionsV1;

    case "retraining-thinking-sleep-thoughts-v1":
      return retrainingThinkingSleepThoughtsV1;

    case "retraining-thinking-focus-v1":
      return retrainingThinkingFocusV1;

    case "survey-focus-question-v1":
      return focusQuestionV1;

    case "values-v1":
      return valuesV1;

    case "progress-v1":
      return progressV1;

    case "progress-rtw-v1":
      return progressRtwV1;

    case "progress-rtw-v1.1":
      return progressRtwV1x1;

    case "progress-rtw-v1.2":
      return progressRtwV1x2;

    case "progress-rtw-us-v1.0":
      return progressRtwUsV1;

    case "progress-rtw-3-month-v1":
      return progressRtw3MonthsV1;

    case "progress-rtw-us-3-month-v1":
      return progressRtwUs3MonthsV1;

    case "perspective-taking-v1":
      return perspectiveTakingV1;

    case "guilt-v1":
      return guiltV1;

    case "sleep-checklist-v1":
      return sleepChecklistV1;

    case "stress-triggers-v1":
      return stressTriggers;

    case "introduction-worry-time-v1":
      return introductionWorryTime;

    case "worry-time-exercise-v1":
      return worryTimeExercise;
    // OLD Surveys - needed for backwards compatibility
    // Preprogram

    case "preprogram-v1":
      return preV1;

    case "preprogram-v1-2":
      return preV1x2;

    case "preprogram-v1-3":
      return preV1x3;

    case "preprogram-v1-4":
      return preV1x4;

    case "preprogram-v1-5":
      return preV1x5;

    case "preprogram-LLv1-5":
      return preLLV1x5;

    case "preprogram-v1-6":
      return preV1x6;

    case "preprogram-v1-6-1":
      return preV1x6x1;

    case "preprogram-v1-7":
      return preV1x7;
    // Preprogram - students

    case "students-preprogram-v1-6":
      return preV1x6Students;

    case "students-preprogram-v1-7":
      return preV1x7Students;
    // Postprogram

    case "postprogram-v1":
      return postV1;

    case "postprogram-v1-2":
      return postV1x2;

    case "postprogram-v1-3":
      return postV1x3;

    case "postprogram-v1-4":
      return postV1x4;

    case "postprogram-v1-5":
      return postV1x5;

    case "postprogram-v1-6":
      return postV1x6;
    // Mindset

    case "exercise-retrainingthinking":
      return exerciseRetrainingThinking;

    case "exercise-retrainingthinking1":
      return exerciseRetrainingThinking;
    // Adv Mindset

    case "exercise1-retrainingthinking2":
      return retraining2exercise1;

    case "exercise2-retrainingthinking2":
      return retraining2exercise2;

    case "exercise1-revision-retrainingthinking2":
      return retraining2RevisionExercise1;

    case "exercise1-stress-retrainingthinking2":
      return retraining2StressExercise1;

    case "exercise1-guilt-retrainingthinking2":
      return retraining2GuiltExercise1;

    case "exercise1-metacognition-retrainingthinking2":
      return retraining2MetacognitionExercise1;

    case "exercise1-beliefs-retrainingthinking2":
      return retraining2BeliefsExercise1;

    case "exercise-balance":
      return exerciseBalance;

    case "exercise-perspectivetaking1":
      return exercisePerspectiveTaking;
    // Wellnesscheck

    case "wellnesscheck-v1":
      return wellnessCheck;

    case "students-wellnesscheck-v1":
      return wellnessCheckStudents;

    case "wellnesscheck15Q-v1":
      return wellnessCheck15Q;
    // Monthly survey

    case "survey-stress-wellbeing-monthly-v1":
      return monthlySurvey;

    case "survey-stress-wellbeing-monthly-v1.1":
      return monthlySurveyV1x1;
    //   case "students-survey-stress-wellbeing-monthly-v1":
    //       return monthlySurveyStudents
    //
    // Students

    case "onboarding-students-v1":
      return onboardingStudentsV1;
    // RTW

    case "exercise-problem-definition":
      return problemDefinition;

    case "exercise-problem-solution":
      return problemSolution;

    case "exercise-before-experiment":
      return beforeExperiment;

    case "exercise-after-experiment":
      return afterExperiment;
    // RTW 2.0

    case "survey-problem-definition-v1":
      return problemDefinitionV1;

    case "survey-problem-solution-v1":
      return problemSolutionV1;

    case "survey-before-experiment-v1":
      return beforeExperimentV1;

    case "survey-after-experiment-v1":
      return afterExperimentV1;

    case "exercise-beliefs-form-1":
      return exerciseRetrainingThinking;

    case "rtw-pre-screener-v1":
      return rtwPreScreenerV1;
    // Preprgram - rtw

    case "rtw-preprogram-v1":
      return preV1Rtw;

    case "allianz-progress-v1":
      return allianzProgressV1;

    case "medibank-progress-v1":
      return medibankProgressV1;

    case "medibank-progress-v1.1":
      return medibankProgressV1x1;

    case "medibank-progress-v1.2":
      return medibankProgressV1x2;

    case "onboarding-medibank-v1.1":
      return onboardingMedibankV1x1;

    case "wellbeingStressWeekly-medibank-v1.1":
      return wellbeingStressWeeklyMedibankV1x1;

    case "wellbeingStressWeekly-medibank-v1.2":
      return wellbeingStressWeeklyMedibankV1x2;

    default:
      return preV1;
  }
};

exports.retrieveSurvey = retrieveSurvey;

var extractRawResults = function extractRawResults(questions, answers) {
  var rawQuestions = {};

  for (var i = 0; i < answers.length; i++) {
    var q = questions[i];

    if (!q.aggregated && !q.key) {
      var qText = q.prompt;
      var ans = "";

      switch (q.type) {
        case "multi":
          ans = q.options[answers[i]];
          break;

        default:
          ans = answers[i];
      }

      rawQuestions[qText] = ans;
    }
  }

  return rawQuestions;
};

var calculateNumericalResults = function calculateNumericalResults(survey, answers) {
  if (!survey || typeof survey === "string") {
    survey = retrieveSurvey(survey);
  }

  var data = survey.analysis(answers, true);
  return data;
};

exports.calculateNumericalResults = calculateNumericalResults;

var calculateResults = function calculateResults(surveyId, answers, bonus) {
  var survey;

  if (typeof surveyId === "string") {
    survey = retrieveSurvey(surveyId);
  } else if (!surveyId) {
    survey = retrieveSurvey(surveyId);
  }

  var data;

  if (survey.analysis) {
    data = survey.analysis(answers, bonus);
  } else if (survey.getSummaryResults) {
    data = survey.getSummaryResults(answers);
  }

  var rawData = extractRawResults(survey.questions, answers);
  return _objectSpread(_objectSpread({}, data), {}, {
    rawData: rawData
  });
};

exports.calculateResults = calculateResults;

var resultsToHtml = function resultsToHtml(survey, answers) {
  var data = calculateResults(survey, answers);
  var res = data.reduce(function (acc, value, key) {
    acc += key + ": <b>" + value + "</b><br/>";
  }, "");
  return res;
};

exports.resultsToHtml = resultsToHtml;